import { atom } from 'recoil';
import { AnnotationState } from 'packages/lib/api/annotations/contract/enums';
import { Task } from 'packages/lib/api/annotations/contract/task';

export const multitaskToolSampleGroupAtom = atom<string | undefined>({
  key: `multitaskToolSampleGroupAtom`,
  default: undefined,
});

export const multitaskToolAnnotationStateAtom = atom<
  AnnotationState | undefined
>({
  key: `multitaskToolAnnotationStateAtom`,
  default: undefined,
});

export const multitaskToolAssigneeAtom = atom<string | undefined>({
  key: `multitaskToolAssigneeAtom`,
  default: undefined,
});

/** Initialized by SyncAssignedMultiTaskDataEffect */
export const multiTasksAtom = atom<Task[] | undefined | null>({
  key: 'multi-task-annotation-tool-tasks-atom',
  default: undefined,
});

/** When object_token is present in the URL, this will be populated with tasks containing that object token (and in the TaskGroup for the sample_group param), with assignment ignored
 * Used for workflows like Scene Enrichment where tasks are linked by Object Token. Used to validate a variety of corner cases */
export const tasksByObjectTokenAtom = atom<Task[] | undefined | null>({
  key: 'tasks-by-object-token-atom',
  default: undefined,
});
